export default "__VITE_ASSET__D2WAmZ45__"